var map = {
	"./banners/Boiled Fish in chili oil.JPG": 41,
	"./banners/Shrimp Balls.JPG": 42,
	"./home/bg-1": 15,
	"./home/bg-1.png": 15,
	"./home/bg-2": 16,
	"./home/bg-2.png": 16,
	"./home/bg-3": 17,
	"./home/bg-3.png": 17,
	"./home/bg-4": 18,
	"./home/bg-4.png": 18,
	"./home/bg-5": 19,
	"./home/bg-5.png": 19,
	"./home/focus-bg": 20,
	"./home/focus-bg.png": 20,
	"./home/focus-bg1": 21,
	"./home/focus-bg1.png": 21,
	"./home/focus-bg2": 22,
	"./home/focus-bg2.png": 22,
	"./home/focus-bg3": 23,
	"./home/focus-bg3.png": 23,
	"./home/focus-bg4": 24,
	"./home/focus-bg4.png": 24,
	"./home/focus-chinese-dining-logo": 25,
	"./home/focus-chinese-dining-logo.png": 25,
	"./home/focus-favicon": 26,
	"./home/focus-favicon.png": 26,
	"./home/focus_card": 27,
	"./home/focus_card.jpeg": 27,
	"./home/focus_dining_logo": 28,
	"./home/focus_dining_logo.png": 28,
	"./home/focus_logo": 29,
	"./home/focus_logo.png": 29,
	"./home/focus_logo1": 30,
	"./home/focus_logo1.png": 30,
	"./home/focus_scan": 31,
	"./home/focus_scan.png": 31,
	"./home/home-about": 32,
	"./home/home-about.png": 32,
	"./home/home-footer": 33,
	"./home/home-footer.png": 33,
	"./home/home-menu": 34,
	"./home/home-menu.png": 34,
	"./menu/m1.JPG": 43,
	"./menu/m10.JPG": 44,
	"./menu/m11.JPG": 45,
	"./menu/m12.JPG": 46,
	"./menu/m2.JPG": 47,
	"./menu/m3.JPG": 48,
	"./menu/m4.JPG": 49,
	"./menu/m5.JPG": 50,
	"./menu/m6.JPG": 51,
	"./menu/m7.JPG": 52,
	"./menu/m8.JPG": 53,
	"./menu/m9.JPG": 54,
	"./slider/Boiled-Fish-in-chili-oil": 35,
	"./slider/Boiled-Fish-in-chili-oil.jpg": 35,
	"./slider/Sichuan-style-poached-sliced-beef": 36,
	"./slider/Sichuan-style-poached-sliced-beef.jpg": 36,
	"./slider/slider1.JPG": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;